import React, { ComponentProps } from "react";

export default function BankNoteIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      {...props}
    >
      <path
        d="M2.36133 7.77962C2.36133 7.86707 2.4109 7.91077 2.49352 7.91077H6.88255C6.3047 7.29167 5.9678 6.22632 5.9678 4.87901C5.9678 3.53756 6.3047 2.47701 6.87085 1.86377H2.49352C2.4109 1.86377 2.36133 1.90748 2.36133 1.9949V7.77962ZM6.711 4.87901C6.711 6.63542 7.31635 7.77777 8.2103 7.77777C9.1356 7.77777 9.7682 6.63542 9.7682 4.87901C9.7682 3.1226 9.1356 1.98716 8.2103 1.98716C7.31635 1.98716 6.711 3.1226 6.711 4.87901ZM9.57425 7.91077H13.9739C14.0565 7.91077 14.1061 7.86707 14.1061 7.77962V1.9949C14.1061 1.90748 14.0565 1.86377 13.9739 1.86377H9.5801C10.1638 2.47701 10.5055 3.53756 10.5055 4.87901C10.5055 6.22632 10.1579 7.29167 9.57425 7.91077Z"
        fill="#6C53E8"
      />
      <path
        d="M0.5 9.27052C0.5 9.57287 0.70121 9.77407 1.00355 9.77407H15.4679C15.7702 9.77407 15.9666 9.57287 15.9666 9.27052V0.499725C15.9666 0.198437 15.7702 0.000976562 15.4679 0.000976562H1.00355C0.70121 0.000976562 0.5 0.198437 0.5 0.499725V9.27052ZM1.71675 8.22837V1.54668C1.71675 1.32812 1.83675 1.21773 2.03773 1.21773H14.4289C14.6347 1.21773 14.7499 1.32812 14.7499 1.54668V8.22837C14.7499 8.44212 14.6347 8.55732 14.4289 8.55732H2.03773C1.83675 8.55732 1.71675 8.44212 1.71675 8.22837Z"
        fill="#6C53E8"
      />
    </svg>
  );
}
